<div class="aya-extra-info">
  <lx-price-lists-portal-aya-program-dates [programDatesBySchool]="programDates"> </lx-price-lists-portal-aya-program-dates>
  <lx-price-lists-portal-aya-session-breaks [sessionBreaksBySchool]="sessionBreaks"> </lx-price-lists-portal-aya-session-breaks>
  <lx-price-lists-portal-aya-supplements [supplements]="supplements"> </lx-price-lists-portal-aya-supplements>
</div>
